export const PDF_X_MARGIN = 48;
export const TEMPLATE_PAGE_HEIGHT = 1122.52;
export const TEMPLATE_PAGE_WIDTH = 793.7;
